import { ru } from "../../ru.js";

const sanctifiedSkillKeys = Object.fromEntries(
  Object.entries(ru)
    .filter(([key]) => key.startsWith("skill."))
    .map(([key, value]) => [`sanctified.${key}`, value])
);

export const sanctifiedRu: Record<string, string> = {
  ...ru,
  ...sanctifiedSkillKeys,
};
